export const formatPhoneLink = (phone: string): string => {
  const cleanPhone = phone.replace(/\D/g, '');
  const prefix = cleanPhone.startsWith('7') ? '+' : '';

  return `tel:${prefix}${cleanPhone}`;
};
